import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import { Amplify } from 'aws-amplify';
import { useMode } from './context/theme';
import './styles/global.scss';
import AuthContextProvider, { AUTH, AuthGuard } from './context/authContext';
import Home from './container/Home';
import { Suspense } from 'react';
import PageLoader from './components/PageLoader';
import { environment } from '../config/env';
import ApplicationContextProvider from './context/applicationContext';
import Login from './container/Login';

Amplify.configure({
  ssr: true,
  Auth: AUTH,
  API: {
    endpoints: [
      {
        name: 'base_url',
        endpoint: `${environment.baseUrl}`,
        region: `${environment.region}`,
      },
    ],
  },
});

const App = () => {
  const { theme } = useMode();

  return (
    <ThemeProvider theme={theme}>
      <AuthContextProvider>
        <ApplicationContextProvider>
          <Suspense fallback={<PageLoader text="Please wait while we load your application" />}>
            <Router>
              <Routes>
                <Route path="login" element={<Login />} />
                <Route
                  path="/"
                  element={
                    <AuthGuard>
                      <Home />
                    </AuthGuard>
                  }
                />
              </Routes>
            </Router>
          </Suspense>
        </ApplicationContextProvider>
      </AuthContextProvider>
    </ThemeProvider>
  );
};

export default App;
